import { SxProps } from '@mui/material';

export const listItemStylesSx: SxProps = {
	padding: '5px 16px 8px 10px',
};
